import CommonService from '../../services/common.service';
import {
  GET_COUNTRIES,
  PREVIEW_DATA,
  COMMON_NOTIFICATION,
  GET_CUSTOMER_BALANCE,
} from '../constants';

export const getCountries = () => async (dispatch) => {
  try {
    const resultData = await CommonService.getCountries();
    dispatch({
      type: GET_COUNTRIES,
      payload: resultData?.data?.length ? resultData.data : [],
    });
  } catch (err) {
    console.log(err);
  }
};

export const getCustomerBalance = () => async (dispatch) => {
  try {
    const resultData = await CommonService.getCustomerBalance();
   
    // if (resultData?.status === true) {
    //   localStorage.setItem('customer_balance', JSON.stringify(resultData?.data && resultData?.data?.balance ? resultData?.data?.balance : 0));
    // }
    dispatch({
      type: GET_CUSTOMER_BALANCE,
      payload: resultData?.data ? resultData.data : {},
    });
  } catch (err) {
    console.log(err);
  }
};

export const previewData = (data) => async (dispatch) => {
  dispatch({
    type: PREVIEW_DATA,
    payload: data,
  });
};

export const setCommonNotification = (message = {}) => {
  return {
    type: COMMON_NOTIFICATION,
    payload: message,
  };
};
